import { render } from "./SenderMessage.vue?vue&type=template&id=3452d832"
import script from "./SenderMessage.vue?vue&type=script&lang=js"
export * from "./SenderMessage.vue?vue&type=script&lang=js"
script.render = render

export default script